document.addEventListener('DOMContentLoaded', function() {
  // Handle variant card selection
  document.querySelectorAll('.variant-card').forEach(card => {
    card.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Get the radio button inside this card
      const radioButton = this.querySelector('input[type="radio"]');
      
      // Remove selected class from all cards in this option group
      const optionGroup = this.closest('.variant-option-cards');
      optionGroup.querySelectorAll('.variant-card').forEach(c => {
        c.classList.remove('selected');
      });
      
      // Add selected class to clicked card
      this.classList.add('selected');
      
      // Check the radio button
      radioButton.checked = true;
      
      // Trigger change event for Shopify variant updates
      radioButton.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});